import React from 'react';
import './index.less';
export default function Detail({
  as: Ele = 'div',
  _label,
  label,
  value
}) {
  return /*#__PURE__*/React.createElement(Ele, {
    className: "cc-detail"
  }, /*#__PURE__*/React.createElement("label", null, label || _label), /*#__PURE__*/React.createElement("span", null, value));
}